import axiosInstance from "auth/FetchInterceptor";
import { NHAPXUAT_API } from "constants/ApiConstant";
const NhapXuatService = {};

NhapXuatService.searchGrid = function (data) {
  return axiosInstance.post(`${NHAPXUAT_API}/search-grid`, data, {
    baseURL: process.env.REACT_APP_PHARMA_ENDPOINT_URL,
  });
};

NhapXuatService.getNhapXuatByManx = function (data) {
  return axiosInstance.get(
    `${NHAPXUAT_API}/get-by-manx?manx=${data.id}&idphieu=${data.idphieu}`,
    {
      baseURL: process.env.REACT_APP_PHARMA_ENDPOINT_URL,
    }
  );
};

NhapXuatService.create = function (data) {
  return axiosInstance.post(NHAPXUAT_API, data, {
    baseURL: process.env.REACT_APP_PHARMA_ENDPOINT_URL,
  });
};
NhapXuatService.update = function (data) {
  return axiosInstance.put(NHAPXUAT_API, data, {
    baseURL: process.env.REACT_APP_PHARMA_ENDPOINT_URL,
  });
};
NhapXuatService.changeStateNhapXuat = function (data) {
  return axiosInstance.put(`${NHAPXUAT_API}/change-state`, data, {
    baseURL: process.env.REACT_APP_PHARMA_ENDPOINT_URL,
  });
};
NhapXuatService.deleteNhapXuat = function (id) {
  return axiosInstance.delete(`${NHAPXUAT_API}/delete-by-manx?manx=${id}`, {
    baseURL: process.env.REACT_APP_PHARMA_ENDPOINT_URL,
  });
};
NhapXuatService.importHoadon = function (data) {
  return axiosInstance.post(`${NHAPXUAT_API}/import-invoice`, data, {
    baseURL: process.env.REACT_APP_PHARMA_ENDPOINT_URL,
  });
};
NhapXuatService.updateHoadonChiTiet = function (data) {
  return axiosInstance.post(`${NHAPXUAT_API}/update-invoice-detail`, data, {
    baseURL: process.env.REACT_APP_PHARMA_ENDPOINT_URL,
  });
};
NhapXuatService.getHoadonChiTiet = function (data) {
  return axiosInstance.get(`${NHAPXUAT_API}/get-invoice-detail?id=${data.id}`, {
    baseURL: process.env.REACT_APP_PHARMA_ENDPOINT_URL,
  });
};
NhapXuatService.chuyenHoaDonThanhPhieuNhap = function (data) {
  return axiosInstance.post(`${NHAPXUAT_API}/convert-invoice-to-import`, data, {
    baseURL: process.env.REACT_APP_PHARMA_ENDPOINT_URL,
  });
};
NhapXuatService.copyPhieuNhapThueSangNoiBo = function (data) {
  return axiosInstance.post(`${NHAPXUAT_API}/copy-phieunhapthue-noibo`, data, {
    baseURL: process.env.REACT_APP_PHARMA_ENDPOINT_URL,
  });
};
NhapXuatService.donViPhieuCuoiCungNhap = function (data) {
  return axiosInstance.get(`${NHAPXUAT_API}/phieu-cuoicung-nhap?loaiphieu=${data}`, {
    baseURL: process.env.REACT_APP_PHARMA_ENDPOINT_URL,
  });
};
export default NhapXuatService;
